module.exports = __webpack_public_path__ + "img/2.80d16811.jpg";